<app-about></app-about>
<app-gallery></app-gallery>
<app-location></app-location>
<app-contact></app-contact>
